import { GridSortModel } from '@mui/x-data-grid-pro';

export { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from 'components/common/dataGrid/constants';

export const INITIAL_SORT_MODEL: GridSortModel = [
  { field: 'createdAt', sort: 'desc' },
];

